export default __webpack_public_path__ + "static/share-3a7d2d92427df2d99bead89bcc5ac9fd.jpg";